export default __webpack_public_path__ + "static/media/SITE03_MEDITATION.36c31549.png";